export default __webpack_public_path__ + "static/media/BeIcon1.0b1a2e0e.svg";